import React from 'react';
import SliderDotList from './SliderDotList';
import SliderDotsContainer from './SliderDotsContainer';
import carouselPropTypes from '../prop-types/carouselPropTypes';

var CarouselDotList = function CarouselDotList(_ref) {
  var dotsType = _ref.dotsType,
      dotsPosition = _ref.dotsPosition,
      dotsAlignment = _ref.dotsAlignment,
      dotsOrientation = _ref.dotsOrientation,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(SliderDotsContainer, {
    dotsType: dotsType,
    dotsPosition: dotsPosition,
    dotsAlignment: dotsAlignment,
    dotsOrientation: dotsOrientation
  }, /*#__PURE__*/React.createElement(SliderDotList, null, children));
};

CarouselDotList.defaultProps = {
  dotsType: 'default',
  dotsPosition: 'outside bottom',
  dotsAlignment: 'center',
  dotsOrientation: 'horizontal',
  children: null
};
export default CarouselDotList;